/**
 * Accessibility helpers for Swiper navigation buttons.
 *
 * Swiper's a11y module sets `aria-controls` on external prev/next buttons pointing
 * to the wrapper id, but with <swiper-container> the wrapper lives inside the
 * shadow DOM, so the reference can never be resolved (axe: aria-valid-attr-value).
 * Button labels come from Fluid (`data-label-prev` / `data-label-next` on the
 * `.slider-navigation` element) so that no UI text is hardcoded here.
 */
export type NavigationA11yParams = {
	prevSlideMessage?: string;
	nextSlideMessage?: string;
};

export function getNavigationA11yParams(navigationContainer: Element | null | undefined): NavigationA11yParams {
	const params: NavigationA11yParams = {};
	if (!(navigationContainer instanceof HTMLElement)) return params;

	const prev = navigationContainer.dataset.labelPrev;
	const next = navigationContainer.dataset.labelNext;
	if (prev) params.prevSlideMessage = prev;
	if (next) params.nextSlideMessage = next;

	return params;
}

export function stripInvalidAriaControls(...elements: Array<Element | null | undefined>): void {
	elements.forEach((element) => element?.removeAttribute('aria-controls'));
}
